import {catalogItems} from "./js/common/catalogItems";
import {add2Basket} from "./js/common/add2basket";
import {registerUser} from "./js/common/registerUser";
import {loginUser} from "./js/common/loginUser";
import {lk} from "./js/common/lk";
import {AutoLoadingSelection} from "./js/common/auto-loading-selection";
import {AutoLoadingProductCard} from "./js/common/auto-loading-product-card";
import {forEach} from "./js/helpers";
import {changeCity} from "./js/common/changeCity";
import axios from 'axios'
import {catalogSort} from "./js/common/catalogSort";

window.axios = axios;

catalogItems();
forEach(document.querySelectorAll('.js-add-to-basket'), $button => {
  $button.addEventListener('click', () => {
    new add2Basket($button, document.querySelector('.js-quantity-input')).init();
  });
});
lk();
forEach(document.querySelectorAll('.itemsBlock'), $itemsBlock => new AutoLoadingSelection($itemsBlock, 'selection').init());
new AutoLoadingProductCard(document, 'product-card').init();
changeCity();
catalogSort();

(function () {
  const form = document.forms['form-register'];
  if (!form) return;
  form.addEventListener('bouncerFormValid', () => {
    registerUser(form);
  }, false);
  form.addEventListener('user-hidden-register', () => {
    location.hash = '#register=true';
    location.reload();
  });
})();

(function () {
  const form = document.forms['form-login'];
  if (!form) return;
  form.addEventListener('bouncerFormValid', () => {
    loginUser(form);
  }, false);
  form.addEventListener('user-login', () => {
    location.hash = '#login=true';
    location.reload();
  });

  bindReachSocialYMGoals();
})();

/**
 * Забиндить события перехода на все соц.сети
 */
function bindReachSocialYMGoals() {
  let elmToGoal = {
    escapeVK: '.vk_link',
    escapeInsta: '.insta_link',
    escapeWA: '.whatsapp_link'
  };

  for (const [goal, cssClass] of Object.entries(elmToGoal)) {
    let elements = document.querySelectorAll(cssClass);

    elements.forEach(function (elm) {
      let parent = elm.parentElement;

      parent.addEventListener('click', function () {
        let fbqGoal = '';

        if(goal === 'escapeWA' || goal === 'escapeTelega')
          fbqGoal = 'Lead';
        else
          fbqGoal = 'SocialMedia';

        if (typeof fbq !== 'undefined')
          fbq('track', fbqGoal, {content_name: document.location});

        if (typeof ym !== 'undefined')
          ym(71116915, 'reachGoal', goal);
      });
    })
  }
}